module.exports = __webpack_public_path__ + "static/media/ios-undo.953f1d72.svg";